<template>
  <div class="container-content">
    <div class="home-container">
    </div>
    <div class="body-container">
      <div class="body-content">
        <span class="location">您现在所在的位置：计量>{{curr}}</span>
        <span  class="search" style="position:relative">
           <input
             placeholder="计量搜索"
             v-model="searchValue"
             />
          <img @click="toCommon({name:'计量',level:'计量机构'})"
               style="width:20px;height:20px;position:absolute;top:20px;right:250px"
               src="../../assets/images/search.svg"
          />
        </span>
      </div>
      <div class="content">
        <div class="content-left">
          <div class="headline">
            <div class="img">
              <img src="../../assets/images/icon/icon-jl.png" alt="">
            </div>
            <div class="word">
              <span class="character">计量</span>
              <span class="english">metering</span>
            </div>
          </div>
          <div class="frame">
            <div class="industry" :class="{active: curr==='政策法规'}" @click="switchPage('政策法规')">政策法规</div>
            <div class="industry" :class="{active: curr==='知识园地'}" @click="switchPage('知识园地')">知识园地</div>
            <div class="industry" :class="{active: curr==='计量授权项目'}" @click="switchPage('计量授权项目')">计量授权项目</div>
            <div class="industry" :class="{active: curr==='实验室认可(CNAS)项目'}" @click="switchPage('实验室认可(CNAS)项目')">实验室认可(CNAS)项目</div>
            <div class="industry" :class="{active: curr==='计量认证(CMA)项目'}" @click="switchPage('计量认证(CMA)项目')">计量认证(CMA)项目</div>
            <div class="industry" :class="{active: curr==='审查认可授权(CAL)项目'}" @click="switchPage('审查认可授权(CAL)项目')">审查认可授权(CAL)项目</div>
            <div class="industry" :class="{active: curr==='计量常识'}" @click="switchPage('计量常识')">计量常识</div>
          </div>
        </div><!--
        --><div class="content-right">
        <div class="details-list" v-if="curr=='政策法规'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Policies and regulat</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1697">《食品检验机构资质认定管理办法》（国家质量监督检验检疫总局总局令第165号）</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1696">《检验检测机构资质认定管理办法》（国家质量监督检验检疫总局总局令第163号）</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=939">中华人民共和国强制检定的工作计量器具明细目录</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=935">河南省计量监督管理条例</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=936">计量标准考核方法</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=928">总局第105号令《计量检定人员管理办法》</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=931">中华人民共和国依法管理的计量器具目录（型式批准部分）</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=930">计量器具新产品管理办法</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=927">关于印发《机动车技术性能检验机构资质认定评审补充要求》的通知</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=934">中华人民共和国工业产品生产许可证管理条例实施办法</a></li>
          </ul>
        </div>
        <div class="details-list" v-if="curr=='知识园地'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Knowledge of garden</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=2173">“温湿度计等新规程新规范宣贯与现场操作演示及测量不确定度评定”高级培训班学习总结</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1977">“北京时间八点整”是咋回事？</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1558">卧式金属罐容量测量的新发展</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1557">磁共振成像系统检测技术初探</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1556">氡测量与标准氡室概述</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1555">一种经济的外照射治疗辐射源测量分析软件</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1554">有关客户关系管理的几点想法</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1553">气相色谱仪检定中出现的问题及解决方法</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1552">浅谈两类生化分析仪计量检定过程中的异同</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1551">关于离子色谱仪检定中的几点建议</a></li>
          </ul>
        </div>
        <div class="details-list" v-if="curr=='计量授权项目'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Metrological authorization item</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/TechnicalSerSerch.aspx?classid=94&KeyWord=&par2=1">国家质量监督检验检疫总局计量授权的检定、校准、检测项目</a></li>
          </ul>
        </div>
        <div class="details-list" v-if="curr=='实验室认可(CNAS)项目'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Laboratory accreditation (CNAS) program</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/TechnicalSerSerch.aspx?classid=94&KeyWord=&par2=2">中国合格评定国家认可委员会实验室认可的检测或校准能力范围</a></li>
          </ul>
        </div>
        <div class="details-list" v-if="curr=='计量认证(CMA)项目'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Metrology certification (CMA) program</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/TechnicalSerSerch.aspx?classid=94&KeyWord=&par2=3">国家认证认可监督管理委员会计量认证的检测能力范围</a></li>
          </ul>
        </div>
        <div class="details-list" v-if="curr=='审查认可授权(CAL)项目'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Review accreditation authority (CAL) programs</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/TechnicalSerSerch.aspx?classid=94&KeyWord=&par2=4">“依托河南省计量科学研究院建立的各质检中心获得河南省质量技术监督局审核认可（验收）的检测能力范围</a></li>
          </ul>
        </div>
        <div class="details-list" v-if="curr=='计量常识'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Measure of common sense</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=2066">仪器设备的三色标准</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1981">校准和检定的区别</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1978">“北京时间八点整”是咋回事？</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1560">出租车计价器你知多少？</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1559">商品量类购物指南</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1548">电子秤作弊手法</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1547">加油三大常见误解</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1546">节能减排与计量的关系</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1545">如何选择电子血压计</a></li>
            <li><a target="_blank" href="http://jly.haqi.gov.cn/HNDetail.aspx?id=1544">如何正确使用水银血压计</a></li>
          </ul>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      curr: '政策法规',
      searchValue: ''
    }
  },
  created () {
    if (this.$route.query.curr) {
      this.curr = this.$route.query.curr;
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    toCommon (obj) {
      this.$store.commit('saveSearchInputValue', this.searchValue);
      this.$store.commit('saveNormalList', [])
      localStorage.setItem('filterValue', obj.name)
      this.$store.commit('saveFilterValue')
      this.$store.commit('saveIsHot', false)
      this.$store.commit('saveIsTopNav', false)
      this.$router.push({ path: '/commonList' })
      this.$store.commit('saveMultipleValue', obj.level)
      this.$store.commit('saveIsSliderNav', true)
    },
    switchPage (page) {
      this.curr = page;
    }
  }
};
</script>

<style lang="less" scoped>
.container-content{
    width: 100%;
    max-width: 1920px;
    .home-container{
      position: relative;
      height: 343.8px;
      width: 100%;
      background-size: 100%;
      background-position: center;
      background-image:url("../../assets/images/metrology.png");
      background-repeat: no-repeat;
    }
    .body-container{
      width:  @body-width;
      margin: 0 auto;
      .body-content{
        width: @body-width;
        line-height: 60px;
        background:#f5f5f5;
        margin: 30px auto 20px auto;
        padding-left: 24px;
        .search{
          input::-webkit-input-placeholder {
             padding-left: 40px;
             opacity: 0.5;
           }
           input{
             width:250px;height:38px;padding-left:30px;border:1px solid @color-base
           }
          padding-right:26px;
          float:right;
          color:#808080;
          font-size:14px;
          font-weight:400;
          cursor:pointer
        }
        .location{
          font-size:14px;
          font-weight:400;
          color:rgba(0,0,0,0.65);
        }
      }
      .content{
        width:  @body-width;
        padding-bottom: 120px;
        margin: 0 auto;
        .content-left{
          display: inline-block;
          width: 244px;
          height: 464px;
          .headline{
            padding: 10px 30px;
            width:244px;
            height:64px;
            background-color: @color-base ;
            .img{
              vertical-align:middle;
              display: inline-block;
              margin-bottom: 30px;
              margin-right: 5px;
            }
            .word{
              display: inline-block;
              .character{
                display: block;
                font-size:18px;
                font-weight:500;
                color:#f5f5f5;
              }
              .english{
                font-size:12px;
                font-weight:400;
                color:rgba(255,255,255,0.4);
              }
            }
          }
          .frame{
            width:220px;
            height:400px;
            background:#f5f5f5;
            padding: 20px 24px;
            .state{
              padding-left: 14px;
              width:220px;
              line-height:36px;
              background-image: url("../../assets/images/icon/bj.svg");
              font-size:16px;
              font-weight:500;
              color:#f5f5f5;
            }
            .industry{
              cursor: pointer;
              padding-left: 14px;
              width:220px;
              line-height:36px;
              font-size:16px;
              font-weight:400;
              color:rgba(0,0,0,0.65);
            }
            .active {
              color:#f5f5f5;
              background-image: url("../../assets/images/icon/bj.svg");
            }
          }
        }
        .content-right{
          padding:24px 0 0 30px;
          vertical-align:top;
          display: inline-block;
          width: 954px;
          min-height: 464px;
          border: 1px solid rgba(0, 0, 0, .1);
          margin-left: -1px;
          .details-list{
            .list-head{
              height: 40px;
              border-bottom: 1px solid rgba(0,0,0,0.1);
              .state-head{
                display: inline-block;
                line-height: 18px;
                padding-right: 12px;
                font-size:18px;
                font-weight:500;
                color:@color-base;
                border-right: 1px solid #D8D8D8;
              }
              .english-head{
                margin-left: 12px;
                display: inline-block;
                font-size:16px;
                font-weight:400;
                color:rgba(@color-base,0.65);
              }
            }
            li:before {
        content: "\2022"; //圆点
        color: rgba(0, 0, 0, 0.25); //颜色
        font-size: 16px;
        padding-right: 8px; //大小
      }
            ul li{
              width:896px;
              line-height:54px;
              border-bottom: 1px solid rgba(0,0,0,0.1);
              a{
                font-size:14px;
                font-weight:400;
                color:rgba(0,0,0,0.85);
              }
            }
             li:hover{
               cursor: pointer;
               color:@color-base;
              box-shadow:0 4px 6px 0 rgba(@color-base,0.1);
               border: none;
            }
            li:hover a{
              color:@color-base;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/metroloylist/metroloyList.vue